import { SendingHoursContext } from 'shared/ui/Schedule/ui/SendingHours/context/SendingHoursContext'
import { type SendingHoursStore } from 'shared/ui/Schedule/ui/SendingHours/store/sendingHoursStore'
import {
  type SendingHoursContentProps,
  SendingHoursContent,
} from 'shared/ui/Schedule/ui/SendingHours/ui/SendingHoursContent'

type ISendingHoursProps = {
  store: SendingHoursStore
} & SendingHoursContentProps

export const SendingHours = ({ store, ...props }: ISendingHoursProps) => (
  <SendingHoursContext.Provider value={store}>
    <SendingHoursContent {...props} />
  </SendingHoursContext.Provider>
)
